import { render, staticRenderFns } from "./free-vip-content.vue?vue&type=template&id=239bd40d&scoped=true"
import script from "./free-vip-content.vue?vue&type=script&lang=js"
export * from "./free-vip-content.vue?vue&type=script&lang=js"
import style0 from "./free-vip-content.vue?vue&type=style&index=0&id=239bd40d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239bd40d",
  null
  
)

export default component.exports